module.exports = __webpack_public_path__ + "img/memolife-white.abe87174.svg";